import React from 'react';
import './CachChoi.css';
import stepImage from '../assets/img/1 (3).jpg';

const CachChoi = () => {
  const steps = [
    {
      number: '01',
      title: 'Đăng ký bằng số điện thoại',
      description: 'Nhập số điện thoại, nhận mã OTP xác thực. Hoàn tất trong 30 giây, không cần thông tin phức tạp.',
      time: '30 giây'
    },
    {
      number: '02',
      title: 'Quay vòng quay may mắn',
      description: 'Click nút "Quay Ngay" để vòng quay bắt đầu. Dừng ở đâu trúng ở đó - từ 100k đến 10 triệu đồng!',
      time: '1 click'
    },
    {
      number: '03',
      title: 'Nhận tiền về tài khoản',
      description: 'Nếu trúng, tiền tự động vào ví. Rút về tài khoản ngân hàng hoặc ví điện tử trong 5 phút.',
      time: '5 phút'
    }
  ];

  return (
    <section className="how-it-works">
      <div className="container">
        <h2 className="section-title">Cách Chơi Game May Mắn</h2>
        <p className="section-subtitle">3 bước đơn giản, trúng ngay tiền thật - Không cần kỹ năng, chỉ cần may mắn!</p>
        
        <div className="steps-container">
          <div className="steps-visual">
            <img src={stepImage} alt="Cách chơi game may mắn" loading="lazy" />
          </div>
          <div className="steps-list">
            {steps.map((step, index) => (
              <div key={index} className="step-item">
                <div className="step-number">{step.number}</div>
                <div className="step-content">
                  <h3 className="step-title">{step.title}</h3>
                  <p className="step-description">{step.description}</p>
                  <span className="step-time">{step.time}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CachChoi;

